namespace SPA
{
	export namespace Realtor2
	{

		export enum EProvision
		{
			ABSOLUTE = 'ABSOLUTE',
			RELATIVE = 'RELATIVE'
		}

		export interface IAObject
		{
			project: 'disposal' | 'let' | 'premise' | '';
			address:
			{
				street: string;
				housenumber: string;
				postalcode: string;
				city: string;
				state: string;
				country: string;
				ags: string;
			};
			quality:
			{
				micro: number;
				macro: number;
				annotation: string;
			};
			seller:
			{
				id: number|null;
			};
			owner:
			{
				id: number|null;
			};
		}

		export interface IDisposalObject extends IAObject
		{
			project: 'disposal';
		}

		export interface IPremiseObject extends IAObject
		{
			project: 'premise';
		}

		export interface IProperty
		{
			area:
			{
				building: number;
				garden: number;
			};
			leasehold:
			{
				present: boolean;
				residual_time: number;
				ground_rent: number;
				disadvantage: number;
				compensation: number;
				rate: number;
				annotation: string;
			};
			structural:
			{
				path: 'private'|'public'|null;
				layout:
				{
					value: 'good'|'bad'|null;
					towel: boolean;
					pipe: boolean;
					corner: boolean;
					slope: boolean;
				};
				garden: 'wip'|'ez'|'avg'|'costly'|null;
				courtyard: 'wip'|'ez'|'avg'|'costly'|null;
				enclosure: 'wip'|'ez'|'avg'|'costly'|null;
				annotation: string;
			};
			register:
			{
				registry_deeds: string;
				court: string;
				volume: string;
				page: string;
				list: Array<{
					no: string|null;
					gemarkung: string|null;
					flur: string|null;
					flurstueck: string|null;
					area: number|null;
					fraction: number|null;
					buildable: boolean;
					GFZ: string|null;
				}>;
				active_annotation: string;
				annotation: string;
			};
			easements: {
				value: 'NOTHING'|'NEED_INSPECTION'|'ABANDON_INSPECTION';
				annotation: string;
			};
			preload: Array<
				{
					no: string|null;
					type: 'LOAD'|'CONSTRAINT'|null;
					definition: string;
					value_approach: number|null;
					value: number|null;
					period: 'MONTHLY'|'YEARLY'|null;
					runtime:
					{
						type: 'MONTH'|'YEAR'|'INF'|null;
						value: number| null;
					};
					rate: number|null;
				}
			>;
			annotation: string;
		}

		export type TSTDST = 1|2|3|4|5|null;

		export interface IEFH
		{
			type: 'EFH';
			roof: 'full'|'empty'|'flat';
			cellar: number; // ! Between 0 and 100 (%),
			floor: number|null;
			features: {
				overall: number|null;
				exterior_wall: TSTDST;
				roof: TSTDST;
				ceiling_stair: TSTDST;
				window_door_out: TSTDST;
				floor: TSTDST;
				heating: TSTDST;
				indoor_wall_door: TSTDST;
				sanitary: TSTDST;
				additional: TSTDST;
			};
		}
		export interface IZFH
		{
			type: 'ZFH';
			roof: 'full'|'empty'|'flat';
			cellar: number|null; // ! Between 0 and 100 (%),
			floor: number|null;
			features: {
				overall: number|null;
				exterior_wall: TSTDST;
				roof: TSTDST;
				ceiling_stair: TSTDST;
				window_door_out: TSTDST;
				floor: TSTDST;
				heating: TSTDST;
				indoor_wall_door: TSTDST;
				sanitary: TSTDST;
				additional: TSTDST;
			};
		}
		export interface IDHH
		{
			type: 'DHH';
			roof: 'full'|'empty'|'flat';
			cellar: number|null; // ! Between 0 and 100 (%),
			floor: number|null;
			features: {
				overall: number|null;
				exterior_wall: TSTDST;
				roof: TSTDST;
				ceiling_stair: TSTDST;
				window_door_out: TSTDST;
				floor: TSTDST;
				heating: TSTDST;
				indoor_wall_door: TSTDST;
				sanitary: TSTDST;
				additional: TSTDST;
			};
		}
		export interface IREH
		{
			type: 'REH';
			roof: 'full'|'empty'|'flat';
			cellar: number|null; // ! Between 0 and 100 (%),
			floor: number|null;
			features: {
				overall: number|null;
				exterior_wall: TSTDST;
				roof: TSTDST;
				ceiling_stair: TSTDST;
				window_door_out: TSTDST;
				floor: TSTDST;
				heating: TSTDST;
				indoor_wall_door: TSTDST;
				sanitary: TSTDST;
				additional: TSTDST;
			};
		}
		export interface IRMH
		{
			type: 'RMH';
			roof: 'full'|'empty'|'flat';
			cellar: number|null; // ! Between 0 and 100 (%),
			floor: number|null;
			features: {
				overall: number|null;
				exterior_wall: TSTDST;
				roof: TSTDST;
				ceiling_stair: TSTDST;
				window_door_out: TSTDST;
				floor: TSTDST;
				heating: TSTDST;
				indoor_wall_door: TSTDST;
				sanitary: TSTDST;
				additional: TSTDST;
			};
		}
		export interface IMFH
		{
			type: 'MFH';
			span: '1'|'2'|'3'|'4';
			units: '-_6'|'7_-_20'| '21_-';
			features: {
				overall: number|null;
				exterior_wall: 3|4|5|null;
				roof: 3|4|5|null;
				ceiling_stair: 3|4|5|null;
				window_door_out: 3|4|5|null;
				floor: 3|4|5|null;
				heating: 3|4|5|null;
				indoor_wall_door: 3|4|5|null;
				sanitary: 3|4|5|null;
				additional: 3|4|5|null;
			};
		}
		export interface IETW
		{
			type: 'ETW';
			features: { overall: 2|3|4|null; };
		}

		export interface IEquipment
		{
			level: // ! If null, level not present, otherwise the element contains its explanation
			{
				1: ui.base.BaseHTMLElement|null;
				2: ui.base.BaseHTMLElement|null;
				3: ui.base.BaseHTMLElement|null;
				4: ui.base.BaseHTMLElement|null;
				5: ui.base.BaseHTMLElement|null;
			};
			classes?: string[];
			name: string;
			title: string;
			value: number|null;
		}

		export interface IObjectCommon
		{
			type: IEFH|IZFH|IDHH|IREH|IRMH|IMFH|IETW|null;
			heating:
			{
				type:
				{
					central: boolean;
					per_floor: boolean;
					per_unit: boolean;
				};
				features:
				{
					gas: boolean;
					oil: boolean;
					electricity: boolean;
					pellet: boolean;
					plant_oil: boolean;
					geothermal_pump: boolean;
					air_heat_exchanger: boolean;
					coal: boolean;
					biomass: boolean;
					radiation: boolean;
					solar: boolean;
					district: boolean;
					log_man: boolean;
					log_auto: boolean;
					floor_heating: boolean;
					heater: boolean;
				};
			};
			annotation: string;
		}

		export interface IParkingSegment
		{
			type: 'GARAGE'|'PARKING'|'CARPORT'|'UNDERGROUND';
			factory_costs: number;
			construction_year: number;
		}

		export interface IObjectDetails
		{
			object:
			{
				usability: 'VERY_GOOD'|'GOOD'|'SATISFYING'|'SUFFICIENT'|'INADEQUAT';
				lettability: 'VERY_GOOD'|'GOOD'|'SATISFYING'|'SUFFICIENT'|'INADEQUAT';
				use_capability: boolean;
				construction_year: number;
				annotation: string;
			};
			living_area:
			{
				type: 'BGF'|'NGF';
				value: number;
			};
			outdoor_facilities:
			{
				type: 'ABSOLUTE'|'RELATIVE';
				value: number;
			};
			parking: IParkingSegment[];
		}

		export interface IModernizationDetail<T = number>
		{
			value: T|null;
			year: number|null;
		}

		export interface IModerizationBool
		{
			value: boolean | 0 | 100 | null;
			year: number;
		}

		export interface IModernization
		{
			object_condition:
			{
				value: 'VERY_GOOD'|'GOOD'|'SATISFYING'|'SUFFICIENT'|'INADEQUAT';
				annotation: string;
			};
			redevelopment:
			{
				redeveloped: boolean;
				windows: IModernizationDetail<number>;
				electricity: IModernizationDetail<number>;
				gas: IModernizationDetail<number>;
				water: IModernizationDetail<number>;
				sewage: IModernizationDetail<number>;
				heating_system: IModernizationDetail<number>;
				sanitary: IModernizationDetail<number>;
				interior: IModernizationDetail<number>;
				roof: IModerizationBool;
				outdoor_walls: IModerizationBool;
				floor_plan: IModerizationBool;
				annotation: string;
			};
			additional:
			{
				value_improving:
				{
					value: number|null;
					annotation: string;
				};
				value_depressing:
				{
					flaws: number|null;
					maintenance_backlog: number|null;
					other: number|null;
					annotation: string;
				};
			};
			annotation: string;
		}

		export interface IFinal
		{
			title: string;
			order_until: {
				value: string|null;
				format: string;
			};
			price:
			{
				value: number;
				currency: 'EUR';
			};
			yearlyRent:
			{
				value: number,
				currency: 'EUR'
			};
			fee: {
				interior:
				{
					type: EProvision;
					value: number;
				}|null;
				exterior:
				{
					type: EProvision;
					value: number;
				}|null;
			};
			soulmandate_from: string;
			soulmandate_to: string;
			annotation: string;
			ref: string;
		}

		export interface IOrderWithFile
		{
			order: boolean;
			file:
			{
				name: string;
				data: string;
				mime: string;
				length: number;
			} | null;
		}

		export interface IOrder
		{
			lrm: boolean;
			register: IOrderWithFile;
			easement: IOrderWithFile;
			datapackage: boolean;
			assessment: {
				immowertv: boolean;
				belwertv: boolean;
				belwertv_bafin: boolean;
			};
		}

	}
}
